"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var firestore_1 = require("firebase/firestore");
var react_1 = __importDefault(require("react"));
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var IconButtons_1 = require("atomicComponents/molecules/IconButtons/IconButtons");
var LogoAndName_1 = __importDefault(require("atomicComponents/molecules/Image/LogoAndName"));
var Money_1 = __importDefault(require("components/Money"));
var Text_1 = __importDefault(require("shared/components/Text"));
var hooks_1 = require("utils/hooks");
var constants_1 = require("./constants");
var ServicePlanWrapper_1 = __importDefault(require("./styles/ServicePlanWrapper"));
var SurveyButton_1 = __importDefault(require("./styles/SurveyButton"));
var TransactionPopup_1 = __importDefault(require("./TransactionPopup"));
var ANSWER_OPTIONS = [true, false, null];
var getText = function (ans) { return (ans && 'Yes') || (ans === false && 'No') || 'Not Sure'; };
var getColor = function (ans) { return (ans && 'success') || (ans === false && 'error') || 'neutral'; };
var ServicePlanRow = function (_a) {
    var item = _a.item, field = _a.field;
    var _b = __read((0, hooks_1.useSubmitter)('service_stats', item.id), 1), updateSStat = _b[0];
    var val = item[field];
    var isAnswered = val !== undefined && ANSWER_OPTIONS.includes(val);
    var last12Months = item.calculatedAnnualSpend || 0;
    var _c = __read(react_1.default.useState(null), 2), anchorEl = _c[0], setAnchorEl = _c[1];
    var handleClick = function () {
        setAnchorEl(anchorEl ? null : divRef.current);
    };
    var divRef = react_1.default.useRef(null);
    return ((0, jsx_runtime_1.jsxs)(ServicePlanWrapper_1.default, __assign({ container: true, flexWrap: "nowrap" }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ sm: 4, item: true, spacing: 1, container: true, alignItems: "center", pt: 1 }, { children: [(0, jsx_runtime_1.jsx)(LogoAndName_1.default, { brand: item.service, size: "sm", fontWeight: "medium" }), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 2, noWrap: true, ml: 1, lineHeight: "40px" }, { children: [(0, jsx_runtime_1.jsx)(Money_1.default, { amount: last12Months, isRounded: true }), " LTM"] }))] })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ sm: 4, item: true, position: "relative", py: 1 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, { ref: divRef, component: "span", position: "absolute", bottom: 48, left: "40%" }), (0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ onClick: handleClick }, { children: "view transactions" })), (0, jsx_runtime_1.jsx)(material_1.Popper, __assign({ anchorEl: anchorEl, open: !!anchorEl, placement: "bottom-start" }, { children: (0, jsx_runtime_1.jsx)(TransactionPopup_1.default, { serviceStat: item, onClose: function () { setAnchorEl(null); } }) }))] })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ sm: 4, item: true, container: true, justifyContent: "flex-end", alignItems: "center", pb: 0.25 }, { children: !isAnswered ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: ANSWER_OPTIONS.map(function (ans) { return ((0, jsx_runtime_1.jsx)(SurveyButton_1.default, __assign({ onClick: function () {
                            var _a;
                            return updateSStat((_a = {}, _a[field] = ans, _a));
                        }, colorOnHover: constants_1.COLOR_MAPPER[getColor(ans)] }, { children: getText(ans) }), getText(ans))); }) })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ fontWeight: "fontWeightMedium", color: constants_1.COLOR_MAPPER[getColor(item[field])], component: "span" }, { children: getText(item[field]) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ pl: 1, mr: -4.375 }, { children: (0, jsx_runtime_1.jsx)(IconButtons_1.UndoButton, { onClick: function () {
                                    var _a;
                                    return updateSStat((_a = {}, _a[field] = (0, firestore_1.deleteField)(), _a), "revert-".concat(field));
                                } }) }))] })) }))] })));
};
exports.default = ServicePlanRow;
